import GeneratedUploadLinkServiceApi from "./generated/GeneratedUploadLinkServiceApi"

class UploadLinkServiceApi extends GeneratedUploadLinkServiceApi {

}

export const uploadLinkServiceApi = new UploadLinkServiceApi()
